import React, { useState, useRef, useEffect } from "react";
import TableButton from "./TableButton";
import "./KebabMenu.css";

const KebabMenu = ({ items = [] }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const handleOutsideClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [open]);

  const base = "wg-table-kebab";

  return (
    <div className={base} ref={menuRef}>
      <TableButton
        variant="icon"
        className={`${base}__trigger`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        aria-label="More actions"
      >
        &#x22EE;
      </TableButton>

      {open && (
        <div className={`${base}__menu`}>
          {items.map((item) => (
            <button
              key={item.label}
              type="button"
              className={`${base}__item${item.disabled ? ` ${base}__item--disabled` : ""}`}
              disabled={item.disabled}
              onClick={(e) => {
                e.stopPropagation();
                if (item.disabled) return;
                setOpen(false);
                item.onClick?.();
              }}
            >
              {item.icon && <span className={`${base}__item-icon`}>{item.icon}</span>}
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default KebabMenu;
